import {CarImageProps} from "./CarImagesComponent";
import {useEffect} from "react";
import {MAX_FETCH_DATA_SIZE, ResourceNames} from "../../config/const";
import {convertDataForSortableImage} from "../../common/image/databaseImageUtils";

export const useCarImageHooks = (props: CarImageProps) => {

    useEffect(() => {
        const awaitFn = async () => {
            await getImages()
        };
        awaitFn().then();
    }, [props.carId])

    const getImages = async () => {
        if (props.carId) {
            const result = await convertDataForSortableImage(props.dataProvider,
                ResourceNames.CAR_IMAGE_RESOURCE,
                {
                    pagination: {page: 1, perPage: MAX_FETCH_DATA_SIZE},
                    sort: {field: 'position', order: 'ASC'},
                    filter: {
                        carId: props.carId,
                        carImageClass: props.carImageClass,
                    }
                }
            )
            props.setImages(result);
        }
    }

}
